import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("mystreetz_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const setToken = (token) => {
    if (token) localStorage.setItem("mystreetz_token", token);
    else localStorage.removeItem("mystreetz_token");
};
export const getToken = () => localStorage.getItem("mystreetz_token");
